export default function Django_Create_User() {
  return <div>Django_Create_User Component</div>;
}
